import { GetStatsDocument } from '#graphql-exports'
import type { Stats } from '@/components/global-stats/types'

interface GetStatsQueryResult {
  Stats: Stats
}

/**
 * SSR-friendly fetch of the site-wide Stats resolver
 * (pledges, schools, cohorts, latest pledge).
 *
 * The initial fetch happens during SSR via `useAsyncQuery`; on the client a
 * polling `useQuery` takes over, starting warm from the SSR-hydrated Apollo
 * cache so there's no flash or duplicate initial request.
 */
export const useGlobalStats = async () => {
  const { data } = await useAsyncQuery<GetStatsQueryResult>(GetStatsDocument)

  const { result } = useQuery<GetStatsQueryResult>(
    GetStatsDocument,
    () => ({}),
    {
      prefetch: false,
      fetchPolicy: 'cache-first',
      pollInterval: 10_000,
      skipPollAttempt: () => document.hidden,
    },
  )

  const stats = computed(() => result.value?.Stats ?? data.value?.Stats ?? null)
  return { stats }
}
